// Arquivo gerado por scripts/generate-api-types.ts a partir da extensão
// `x-constantes` do documento OpenAPI. Não editar.

export const PLANOS_ORDENADOS = [
  'Gateway',
  'Basic',
  'PRO',
  'Ultimate',
  'Corporate',
] as const;

export const FUNCIONALIDADES_PLANOS_MINIMOS = {
  IASuporteAutomatico: 'Gateway',
  AuditoriaPreventiva: 'Basic',
  AdmissaoDigital: 'Ultimate',
  ControleFerias: 'Ultimate',
  GestaoArquivos: 'Ultimate',
} as const;

export const CLIENTE_IDS = {
  CONTA_SECULLUM: '1',
  GATEWAY: '2',
  PONTO_SECULLUM_WEB: '3',
  PONTO_WEB_UI: '3001',
  INTEGRACAO_EXTERNA_PONTO_WEB: '3002',
  SITE_SECULLUM: '4',
  EMOB: '5',
  AREA_REVENDA: '6',
  HEALTH_CHECK: '7',
  PONTO_VIRTUAL_WEB: '8',
} as const;

export const FUNCIONALIDADES_BANCO = [
  { nome: 'AdmissaoDigital', status: 'em-breve', planoMinimo: 'Ultimate' },
  { nome: 'IASuporteAutomatico', status: 'beta', planoMinimo: 'Gateway' },
  { nome: 'AuditoriaPreventiva', status: 'disponivel', planoMinimo: 'Basic' },
  { nome: 'ChatCorporativo', status: 'em-breve', planoMinimo: 'Ultimate' },
  { nome: 'Beneficios', status: 'em-breve', planoMinimo: 'Ultimate' },
  { nome: 'ControleEPI', status: 'em-breve', planoMinimo: 'Ultimate' },
  { nome: 'ControleFerias', status: 'disponivel', planoMinimo: 'Ultimate' },
  { nome: 'GestaoArquivos', status: 'disponivel', planoMinimo: 'Ultimate' },
  { nome: 'PesquisaClima', status: 'em-breve', planoMinimo: 'Ultimate' },
  { nome: 'PlanoCargos', status: 'em-breve', planoMinimo: 'Ultimate' },
] as const;
